export const UPDATE = 'UPDATE';
export const CART_LOADING = 'CART_LOADING';
export const UPDATE_FC_SETTINGS = 'UPDATE_FC_SETTINGS';